import { createSignal, createRoot } from 'solid-js';

// 使用createRoot创建store，缓存的是dom，没有水合问题
function createAnimationTargets() {
  const [betSlipTabTarget, setBetSlipTabTarget] = createSignal<HTMLElement | null>(null);

  return {
    betSlipTabTarget,
    setBetSlipTabTarget,
  };
}

export const { betSlipTabTarget, setBetSlipTabTarget } = createRoot(createAnimationTargets);
